// extracted by mini-css-extract-plugin
export default {"scrollHidden":"App_scrollHidden__Ry4Bo","wrapper":"App_wrapper__+tchH"};